import { render } from "./FormPieceDeCaisse.vue?vue&type=template&id=6c1e2074"
import script from "./FormPieceDeCaisse.vue?vue&type=script&lang=js"
export * from "./FormPieceDeCaisse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__